module.exports = __webpack_public_path__ + "img/becamo-logo.c28acf39.png";